module.exports = __webpack_public_path__ + "static/media/13.04b0a816.jpg";